import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Product from '../entities/product';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';

interface ProductState extends ListState<Product> {
    editProduct: Product;
}
class ProductModule extends ListModule<ProductState, any, Product> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Product>(),
        loading: false,
        editProduct: new Product(),
    };
    public actions = {
        async get(context: ActionContext<ProductState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Product/Get?Id=' + payload.data.id);
            return reponse.data.result as Product;
        },
        async getByItemno(context: ActionContext<ProductState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Product/GetByItemno?itemno=' + payload.data.id);
            return reponse.data.result as Product;
        },
        async getProductsByIDs(context: ActionContext<ProductState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/Product/GetProductssByIDs', { params: payload.data });
            return reponse.data.result;
        },
        async getProductsByDetailID(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductsBySettingDetailIDFromCache', { params: payload.data });
            return reponse.data.result;
        },
        async getProductsByDetailIDList(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductsBySettingDetailIDFromCacheList', { params: payload.data });
            return reponse.data.result;
        },
        async getProductsByActivitiess(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        }
        ,
        async getProductClass(context: ActionContext<ProductState, any>, payload: any) {//大类
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductClassFromCache', { params: payload.data });
            return reponse.data.result;
        },
        async getProductSmallClass(context: ActionContext<ProductState, any>, payload: any) {//小类
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/Product/GetProductSmallClassFromCache', { params: payload.data });
            return reponse.data.result;
        },
        async getitemInfoShow(context: ActionContext<ProductState, any>, payload: any)
        {
          const reponse=  await Ajax.get("/api/services/app/Item_Info_Show/Getitem_info_show");
          return reponse.data.result;
        },

        async getPagedProducts(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
           // const reponse = await Ajax.get('/api/services/app/Product/GetMobilePagedProducts', { params: payload.data });
           const reponse = await Ajax.get('/api/services/app/Product/GetMobilePagedGoods', { params: payload.data });
            return reponse.data.result;
        },
        async getProductsLimit(context: ActionContext<ProductState, any>, payload: any) {
            return new Promise(function (resolve, reject) {
                Ajax.get('/api/services/app/Product/GetProductsLimit', { params: payload.data })
                .then(res=>{
                    resolve(res.data.result);
                }).catch(res=>{
                    reject(res.response.data);
                })
            });
        },
        async getItemCommentList(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/OrderComment/GetItemCommentList', { params: payload.data });
            return reponse.data.result;
        },
         //活动隔离-满减
         async getProductsByActivitiess_MobileBuyFull(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        },
        //活动隔离-满减
        async getByItemno_MobileBuyFull(context: ActionContext<ProductState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobileBuyFull/GetByItemno?itemno=' + payload.data.id);
            return reponse.data.result as Product;
        },
         //活动隔离-拼团
         async getProductsByActivitiess_MobilePintuan(context: ActionContext<ProductState, any>, payload: any) {
            // tslint:disable-next-line:max-line-length
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetProductssByActivities', { params: payload.data });
            return reponse.data.result;
        },
        //活动隔离-拼团
        async getByItemno_MobilePintuan(context: ActionContext<ProductState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/MobilePintuan/GetByItemno?itemno=' + payload.data.id);
            return reponse.data.result as Product;
        },
    };
    public mutations = {
        setCurrentPage(state: ProductState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProductState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: ProductState, product: Product) {
            state.editProduct = product;
        },
    };
}
const productModule = new ProductModule();
export default productModule;
